import React from "react";
import Team from "../components/Team/Team";
import "./AboutUsStyle.css";

function AboutUs() {
  return (
    <div className="about-container">
      <section className="about-section">
              
        <h1>Who we are</h1>
        <p>
         GÖKÇE Capital Investments Pvt Ltd is a visionary holding company dedicated to strategic investment portfolio management. With a focus on equity holdings across diverse sectors, GÖKÇE acts as a financial catalyst — distributing investor capital through shares, bonds, equity options (EOPs), and other instruments to fuel growth and maximize returns.
        </p>

 <h1>Our Philosophy</h1>
        <p>
          Just like the GÖKÇE emblem — a phoenix in flight — our investments are designed to rise, evolve, and thrive. We don’t just invest; we guide ventures toward their highest potential, ensuring every portfolio company is on the right growth trajectory.
          </p>
      </section>

      <section className="about-section">
        <h2>Our Edge</h2>
        <ul>
          <li>Proven track record of successful exits and IPO participation.</li>
          <li>Deep expertise in structuring equity and financial instruments.</li>
          <li>Commitment to investor value and long-term scalability.</li>
          <li>Active involvement in portfolio company governance and growth.</li>
        </ul> 
      </section>


  
    </div>
  );
}

export default AboutUs;